import { render } from "./BoardUser.vue?vue&type=template&id=ee9a2408"
import script from "./BoardUser.vue?vue&type=script&lang=js"
export * from "./BoardUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ratul/Code/vue/jourly-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__